module.exports = __webpack_public_path__ + "static/media/navigation-icon-1.253dc5b0.svg";